import { useIntercom } from 'react-use-intercom'
import { Column } from '../../components/Layout/Column'
import { Body, Button, Spacer } from '@spritz-finance/ui'
import { Row } from '../../components/Layout/Row'
import React from 'react'

export const FailureCard = () => {
    const { show: openIntercom } = useIntercom()
    const contactSupport = () => {
        openIntercom()
    }

    return (
        <Column align="center">
            <Body.SmBold size={14}>
                Identity verification failed. Please contact support.
            </Body.SmBold>
            <Spacer height={24} />
            <Row align="center">
                <Button.CTA onClick={contactSupport}>Contact Support</Button.CTA>
            </Row>
        </Column>
    )
}
